import React from "react";

const values = [
  {
    icon: "🤝",
    title: "Farmer First",
    desc: "Every decision we make starts with understanding real farmer needs, field challenges, and practical farming conditions."
  },
  {
    icon: "✅",
    title: "Quality & Reliability",
    desc: "We never compromise on quality. From raw materials to final products, consistency and performance are non-negotiable."
  },
  {
    icon: "🌱",
    title: "Sustainability",
    desc: "We believe long-term agricultural success depends on protecting soil health, water resources, and the environment."
  },
  {
    icon: "🔬",
    title: "Innovation",
    desc: "Continuous research, field trials, and innovation help us develop better, safer, and more effective solutions."
  },
  {
    icon: "🛡️",
    title: "Integrity & Ethics",
    desc: "Honesty, transparency, and ethical practices guide our relationships with farmers, partners, and stakeholders."
  },
  {
    icon: "🚜",
    title: "Growth Together",
    desc: "Our growth is meaningful only when farmers grow with us — through better yields, reduced losses, and confidence."
  }
];

const CoreValues = () => {
  return (
    <section className="core-values-section">
      <div className="container">

        <div className="text-center mb-5">
          <h6 className="section-subtitle">OUR CORE VALUES</h6>
          <h2 className="section-title">
            What <span>We Believe In</span>
          </h2>
          <p className="section-desc">
            Our values define who we are, how we work, and the commitments
            we uphold while serving Indian agriculture.
          </p>
        </div>

        <div className="row">
          {values.map((item, index) => (
            <div className="col-lg-4 col-md-6 mb-4" key={index}>
              <div className="value-card">
                <div className="value-icon">{item.icon}</div>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default CoreValues;
